import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { EngagementFollowUp, EngagementGridContainerPage } from '@interfaces';
import { AppService, BaseEngagementService, DomainDataService } from '../../../../../services';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';

export function getSetup(pageService: BaseEngagementService, util: UtilityService, dialog: DialogService, app: AppService, page: EngagementGridContainerPage | undefined, domainDataService: DomainDataService): GridSetup<EngagementFollowUp> {
	return {
		rowName: { singular: 'Follow-Up', plural: 'Follow-Ups' },
		getRowKey: row => '' + row.followUpId,
		stateKey: (`${page}-scheduled-follow-ups-grid`).toLowerCase(),
		actions: getActions(pageService, dialog),
		buttons: getButtons(pageService, dialog),
		columns: getColumns(util, app, domainDataService),
		renderRowClasses: row => [],
		multiselect: false,
	}
}
